export const mock_projects = [
	{
		project_id: 1,
		user_id: 101,
		project_name: 'Immobility Website',
		project_description:
			'Developing a responsive website for an immobility solutions company with advanced features.',
		project_url: 'https://immobility.example.com',
		created_at: '2023-01-01T12:00:00',
		is_permanent: 1,
		is_finished: 0,
	},
	{
		project_id: 2,
		user_id: 102,
		project_name: 'Mobilität-App',
		project_description:
			'Entwicklung einer nachhaltigen, benutzerfreundlichen Mobilität-App zur Förderung von umweltfreundlichen Verkehrsoptionen. Die App bietet Echtzeitinformationen zu öffentlichen Verkehrsmitteln, Fahrradverleihen und Fußwegen. Ziel: Reduzierung des individuellen CO2-Fußabdrucks und Förderung eines nachhaltigen Lebensstils.',
		project_url: 'https://techblog.example.com',
		created_at: '2023-02-15T14:30:00',
		is_permanent: 0,
		is_finished: 0,
	},
	{
		project_id: 3,
		user_id: 103,
		project_name: 'Online-Lernportal',
		project_description:
			'Entwurf und Implementierung eines interaktiven Online-Lernportals für Schüler: Eine benutzerfreundliche Plattform, die personalisierte Lernressourcen, interaktive Übungen und Fortschrittsverfolgung bietet. Ziel: Effektive und individualisierte Bildungsförderung für Schüler aller Altersgruppen.',
		project_url: 'https://webshop.example.com',
		created_at: '2023-03-20T09:45:00',
		is_permanent: 1,
		is_finished: 1,
	},
	{
		project_id: 4,
		user_id: 104,
		project_name: 'Gesundheit-Tracker',
		project_description:
			'Entwicklung eines innovativen Gesundheit-Trackers: Ein Wearable, das Vitalparameter wie Herzfrequenz und Schlafmuster überwacht. Die zugehörige App bietet personalisierte Gesundheitsempfehlungen basierend auf den gesammelten Daten. Ziel: Förderung eines bewussten Lebensstils und frühzeitige Erkennung von Gesundheitsrisiken.',
		project_url: 'https://travelblog.example.com',
		created_at: '2023-04-10T18:20:00',
		is_permanent: 0,
		is_finished: 1,
	},
];

export const mock_users = [
	{
		user_id: 1,
		email: 'user1@example.com',
		password_hash: 'hashed_password_1',
		first_name: 'John',
		last_name: 'Doe',
		settings: '{"theme": "light", "language": "en"}',
		created_at: '2023-01-01T08:00:00',
		is_admin: 0,
		is_disabled: 0,
		is_deleted: 0,
	},
	{
		user_id: 2,
		email: 'user2@example.com',
		password_hash: 'hashed_password_2',
		first_name: 'Jane',
		last_name: 'Smith',
		settings: '{"theme": "dark", "language": "de"}',
		created_at: '2023-02-15T14:30:00',
		is_admin: 0,
		is_disabled: 0,
		is_deleted: 0,
	},
	{
		user_id: 3,
		email: 'admin@example.com',
		password_hash: 'hashed_password_admin',
		first_name: 'Admin',
		last_name: 'User',
		settings: '{"theme": "dark", "language": "en"}',
		created_at: '2023-03-20T09:45:00',
		is_admin: 1,
		is_disabled: 0,
		is_deleted: 0,
	},
	{
		user_id: 4,
		email: 'disabled_user@example.com',
		password_hash: 'hashed_password_disabled',
		first_name: 'Disabled',
		last_name: 'User',
		settings: '{"theme": "light", "language": "de"}',
		created_at: '2023-04-10T18:20:00',
		is_admin: 0,
		is_disabled: 1,
		is_deleted: 0,
	},
	{
		user_id: 5,
		email: 'deleted_user@example.com',
		password_hash: 'hashed_password_deleted',
		first_name: 'Deleted',
		last_name: 'User',
		settings: '{"theme": "light", "language": "en"}',
		created_at: '2023-05-25T12:00:00',
		is_admin: 0,
		is_disabled: 0,
		is_deleted: 1,
	},
];

export const mock_checks = [
	{
		check_id: 1,
		check_name: 'Google Page Speed',
		check_description:
			'Fragt die Google Pagespeed API ab, holt die Werte für Leistung, Barrierefreiheit, Best Practices und SEO und prüft, ob die Mindestanforderungen dieser Werte erfüllt werden.',
		check_method: 'googlepagespeed',
		created_at: '2023-01-01T08:00:00',
		is_mandatory: 1,
		is_deleted: 0,
	},
	{
		check_id: 2,
		check_name: 'Mobile Friendly Test',
		check_description:
			'Überprüft, ob eine Website mobilfreundlich ist und für Mobilgeräte optimiert wurde.',
		check_method: 'mobilefriendly',
		created_at: '2023-02-15T14:30:00',
		is_mandatory: 1,
		is_deleted: 0,
	},
	{
		check_id: 3,
		check_name: 'Link Checker',
		check_description: 'Durchsucht eine Website nach defekten oder nicht erreichbaren Links.',
		check_method: 'linkchecker',
		created_at: '2023-03-20T09:45:00',
		is_mandatory: 0,
		is_deleted: 0,
	},
];

